export default "__VITE_ASSET__BxNC2laA__"